import { HugeiconsIcon } from "@hugeicons/react";
import { Alert02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, ButtonSize, ButtonVariant } from "shared/components";

const bannerTitle = (count: number) =>
  count === 1
    ? "1 available unit needs a lockbox"
    : `${count} available units need a lockbox`;

export const NeedsLockboxBanner = ({
  count,
  isFiltered,
  onToggle
}: {
  count: number;
  isFiltered: boolean;
  onToggle: () => void;
}) => (
  <div
    role="status"
    className="mb-4 flex flex-wrap items-center gap-3 rounded-lg border border-warning-100 bg-warning-50 px-4 py-3 md:flex-nowrap"
  >
    <HugeiconsIcon
      icon={Alert02Icon}
      size={20}
      className="shrink-0 text-warning-600"
    />
    <div className="min-w-0 flex-1 text-sm text-warning-800">
      <p className="m-0 font-bold">{bannerTitle(count)}</p>
      <p className="m-0">
        These units use self-guided showings, but no lockbox is linked. Leads
        who book a tour won&apos;t receive an access code.
      </p>
    </div>
    <Button
      variant={ButtonVariant.BASE}
      size={ButtonSize.SM}
      className="shrink-0 !border-warning-100 !text-warning-800"
      onClick={onToggle}
    >
      {isFiltered ? "Show all units" : "View units"}
    </Button>
  </div>
);
